import script from "./CustomerBehaviorDueCohort.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerBehaviorDueCohort.vue?vue&type=script&setup=true&lang=js"

import "./CustomerBehaviorDueCohort.vue?vue&type=style&index=0&id=67cc235a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67cc235a"]])

export default __exports__